<template>
  <div class="rdiv">
    <div style="position: relative; height: 450px; overflow: scroll; text-align: center;">
      <img id="pic" :src="form.url" :width="form.width" :height="form.height">
      <div style="position: relative;" :style="{top: -form.height - 5 + 'px', left: (w - form.width)/2 - 9 + 'px'}">
        <label v-for="item in form.certTemplatePointLoactionList" v-if="item.pointValue" :key="item.pointKey" :data-key="item.pointKey" :data-value="item.pointValue" :data-label="item.pointLabel" :style="{left: item.localX + 'px', top: item.localY + 'px'}" class="drag" style="position: absolute">
          {{item.pointValue}}
        </label>
      </div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  export default {
    mounted () {
      this.getModel(this.id)
    },
    computed: {
    },
    data () {
      return {
        form: {}
      }
    },
    props: ['id', 'p', 'w'],
    methods: {
      getModel (id) {
        var that = this
        api.post(config.certApiPath, '/cert-instances/' + id, this.p, function (r) { // 正常
          that.form = r.data
        })
      }
    }
  }
</script>

<style scoped>
  .drag {
    min-width: 40px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    padding: 0 1px;
    font-size: 18px;
    color: #000;
    z-index: 6;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/cert/display.vue